import React, { FC } from 'react';

import AccessCounterLine from 'buyside/components/presentation/RemainingAccess/AccessCounterLine/accessCounterLine';
import NavigationUserInfoSection from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/navigationUserInfoSection';

import BriefcaseIcon from 'BuysideSVGs/briefcase.svg';
import CoinStack from 'BuysideSVGs/coin_stack.svg';
import HandshakeIcon from 'BuysideSVGs/handshake.svg';
import LightBulbIcon from 'BuysideSVGs/lightbulb.svg';
import MessageBubbleIcon from 'BuysideSVGs/message_bubble.svg';
import QuestionMarkIcon from 'buyside/svgs/question_mark.svg';
import StarIcon from 'BuysideSVGs/star.svg';

const UserAccess: FC<{
  isPaladin: boolean;
  quotaData: (quotaType: string) => any;
  accessData: (accessType: string) => any;
  canWriteIdeas: boolean;
  hasPollAnswerQuota: boolean;
}> = ({ isPaladin, quotaData, accessData, canWriteIdeas, hasPollAnswerQuota }) => {
  return (
    <NavigationUserInfoSection title="Your Remaining Access">
      {isPaladin ? (
        <>
          <AccessCounterLine title="Ratings" icon={StarIcon} accessData={quotaData('rating')} />
          <AccessCounterLine
            title="Comments"
            icon={MessageBubbleIcon}
            accessData={quotaData('comment')}
          />
          {hasPollAnswerQuota && (
            <AccessCounterLine
              title="Poll Answers"
              icon={QuestionMarkIcon}
              accessData={quotaData('pollAnswer')}
            />
          )}
        </>
      ) : (
        <>
          <AccessCounterLine
            title="Research"
            icon={LightBulbIcon}
            accessData={accessData('idea')}
            canWriteIdeas={canWriteIdeas}
          />
          <AccessCounterLine
            title="Cap Intro"
            icon={HandshakeIcon}
            accessData={accessData('capIntro')}
          />
          <AccessCounterLine
            title="Job Vault"
            icon={BriefcaseIcon}
            accessData={accessData('job')}
          />
          <AccessCounterLine
            title="Comp"
            icon={CoinStack}
            accessData={accessData('compensation')}
          />
        </>
      )}
    </NavigationUserInfoSection>
  );
};

export default UserAccess;
